module.exports = __webpack_public_path__ + "img/ins-name.4f7430ba.svg";